const setCsvHeaders = (promoType, rewardType, specialData) => {
  let csvHeaders = {
    name: { title: "Name" },
    barcode: { title: "Barcode" },
    stockNo: { title: "Stock No." },
    retailPrice: { title: "Retail Price" },
    discount: { title: "Percent Discount" }
  }

  if (promoType == 1 && rewardType != '1') {
    const title = rewardType == '2' ? "Amount Discount" : "New Price";
    csvHeaders = {
      ...csvHeaders,
      discount: { title: title },
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 2) {
    const discountTitle = rewardType == '1' || specialData.applyLevel != 'IL' ? "Multi-Level Discount" : "Percent Discount";
    const requiredTitle = rewardType == '2' ? "Minimum Amount" : "Required Quantity";
    if (rewardType != '1' && specialData.applyLevel == 'IL') {
      csvHeaders = { ...csvHeaders, requiredValue: { title: requiredTitle } }
    }

    csvHeaders = {
      ...csvHeaders,
      discount: { title: discountTitle },
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 3 && rewardType == '1') {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      requiredValue: { title: "Buy Qty" },
      discount: { title: "Take Qty" },
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 4) {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 5) {
    delete csvHeaders["discount"];
  } else if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      requiredValue: { title: "Quantity" },
      itemType: { title: "Item Type (P: Prerequisite, B: Bonus)" }
    }
  } else if ((promoType == 3 && rewardType == '2') ||
             (promoType == 6)) {
    delete csvHeaders["discount"];
    csvHeaders = { ...csvHeaders, requiredValue: { title: "Quantity" } }
  }

  return csvHeaders
}

const exportProduct = (promoType, rewardType, requiredProduct, rewardProducts=[], specialData={}) => {
  let csvData = [];

  // console.log(requiredProduct);
  // console.log(rewardProducts);

  if ([1,2,3,4,5,6].includes(promoType)) {
    requiredProduct.map(product => {
      let data = {
        name: product.name,
        barcode: product.barcode,
        stockNo: product.stock_no,
        retailPrice: product.retail_price,
        discount: product.promo_value,
        requiredValue: product.required_value,
        limit: product.max_application,
        round: product.round_to_nearest
      }

      if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
        data.itemType = 'P'
      }

      csvData.push(data)
    })
  }

  if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
    rewardProducts.map(product => {
      csvData.push({
        name: product.name,
        barcode: product.barcode,
        stockNo: product.stock_no,
        retailPrice: product.retail_price,
        discount: product.promo_value,
        requiredValue: product.required_value,
        limit: product.max_application,
        round: product.round_to_nearest,
        itemType: 'B'
      })
    })
  }

  return csvData;
}

const exportProductCSV = (promoType=0, rewardType="", requiredProduct=[], rewardProducts=[], specialData={}) => {
  const csvHeaders = setCsvHeaders(promoType, rewardType, specialData);
  const csvData = exportProduct(promoType, rewardType, requiredProduct, rewardProducts, specialData);

  return {
    csvHeaders,
    csvData
  }
}

export { exportProductCSV }
